angular.module('app.home.timeline')

.controller('HomeTimelineCtrl', function($scope, $rootScope, $http, $filter){
    $scope.timeline = [
        {label: 'Last 7 days', value: 7, ticked: true},
        {label: 'Last 15 days', value: 15},
        {label: 'Last 30 days', value: 30},
        {label: 'Last 60 days', value: 60},
        /*{label: 'Last 90 days', value: 90}*/
    ];

    if ($rootScope.selectedPeriod.period != null) {
        angular.forEach($scope.timeline, function (item) {
            if (item.value == $rootScope.selectedPeriod.period.value) {
                item.ticked = true;
            } else {
                item.ticked = false;
            }
        })
    } else {
        $rootScope.selectedPeriod.period = {
            label: 'Last 7 days', value: 7, ticked: true
        }
    }

    $scope.activityChart = {
        options: {
            chart: {
                type: 'line',
                zoomType: 'x',
                events: {
                    redraw: function(){
                        $('.highcharts-markers').attr('visibility', 'hidden');
                    }
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                line: {
                    marker: {
                        enabled: true,
                        symbol: "circle",
                        fillColor: "#fff",
                        lineColor: null,
                        lineWidth: 3,
                        radius: 4,
                        states: {
                            hover: {
                                enabled: true,
                                symbol: "circle",
                                fillColor: "#fff",
                                lineColor: "#000",
                                lineWidth: 3,
                                radius: 4
                            }
                        }
                    },
                    events: {
                        mouseOver: function (event) {
                            this.markerGroup.attr('visibility', 'visible');
                        },
                        mouseOut: function(event) {
                            this.markerGroup.attr('visibility', 'hidden');
                        }
                    }
                }
            },
            tooltip: {
                useHTML: true,
                followPointer: false,
                backgroundColor: "#333b48",
                pointFormatter: function () {
                    return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                },
                headerFormat: "",
                borderRadius: 24,
                borderWidth: 0,
                shadow: false,
                shape: "callout",
                style: {
                    "color": "#FFFFFF",
                    "padding": "6"
                }
            }
        },
        series: [],
        title: {
            text: ''
        },
        xAxis: {
            type: 'datetime',
            labels: {
                useHTML: true,
                format: "{value:%d %b}",
                style: {
                    fontFamily: "ProximaNovaRegular",
                    letterSpacing: "1px",
                    paddingTop: "10px",
                    textTransform: "uppercase",
                }
            },
            tickLength: 0
        },
        yAxis: {
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0, 0, ',');
                },
                style:{
                    fontFamily: "ProximaNovaRegular",
                }
            }
        },
        noData: 'Pending Data...',
        loading: true
    };

    $scope.$on('refreshDashboard', function(event, args) {
        $scope.activityChart.series = [];
        $scope.loadChartData();
    });

    $scope.changeActivityGraph = function(data){
        $rootScope.selectedPeriod.period = data;       
        $rootScope.$broadcast('refreshDashboard', {});
    }

    $scope.loadChartData = function(){
        $scope.activityChart.loading = true;
        var params = $rootScope.saveParams;
        if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
            return;
        } 
        params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

        var url = $rootScope.apiUrl + 'home/getPerformanceReportTimeLineChart?' + $.param(params);

        $http.get(url, {loader: false})
            .success(function(response){
                var impressionsLine = { name: 'Impressions', data: [], color: '#55E9A9' };
                var reachLine = { name: 'Reach', data: [], color: '#FF6C9D' };
                var engagementLine = { name: 'Engagement', data: [], color: '#00D6EF' };
                angular.forEach(response.data, function(item) {
                    angular.forEach(item, function(result) {
                        impressionsLine.data.push([result.date, parseFloat(result.impressions.toFixed(2))]);
                        reachLine.data.push([result.date, parseFloat(result.reach.toFixed(2))]);
                        engagementLine.data.push([result.date, parseFloat(result.engagement.toFixed(2))]);
                    }) 
                })
                
                $scope.activityChart.series = [];     
                $scope.activityChart.series.push(impressionsLine);
                $scope.activityChart.series.push(reachLine);          
                $scope.activityChart.series.push(engagementLine);
                $scope.activityChart.loading = false;
                $scope.$broadcast('highchartsng.reflow');
                $scope.activityChart.title.text = "";
            }) .error(function (data) {
                $scope.activityChart.loading = false;
                $scope.activityChart.noData = "";
                $scope.activityChart.title.text = "Failed to load data";
            })
    }

    $scope.loadChartData();
})


